import { Box, Chip } from '@mui/material'
import React from 'react'
import { referenceMenus } from './referenceMenuConfig'

interface ReferenceMenuBarProps {
  activeMenu: string | null
  onToggleMenu: (menuId: string) => void
  extraChips?: React.ReactNode
}

const ReferenceMenuBar: React.FC<ReferenceMenuBarProps> = ({ activeMenu, onToggleMenu, extraChips }) => {
  return (
    <Box sx={{ display: 'flex', gap: 0.75, pt: 1, flexWrap: 'wrap', alignItems: 'center' }}>
      {referenceMenus.map(menu => {
        const Icon = menu.icon
        const isActive = activeMenu === menu.id
        return (
          <Chip
            key={menu.id}
            icon={<Icon sx={{ fontSize: 14 }} />}
            label={menu.label}
            size="small"
            variant={isActive ? 'filled' : 'outlined'}
            onClick={() => onToggleMenu(menu.id)}
            sx={{
              cursor: 'pointer',
              fontSize: '0.7rem',
              height: 24,
              p: 1.0,
              borderColor: 'text.ai_agent_text',
              color: isActive ? 'text.primary' : 'text.ai_agent_text',
              bgcolor: isActive ? 'action.selected' : 'transparent',
              transition: 'all 0.2s ease',
              '& .MuiChip-icon': {
                color: isActive ? 'text.primary' : 'text.ai_agent_text',
              },
              '&:hover': {
                borderColor: 'text.highlight',
                color: 'text.primary',
                '& .MuiChip-icon': { color: 'text.primary' },
              },
            }}
          />
        )
      })}
      {extraChips}
    </Box>
  )
}

export default ReferenceMenuBar
